var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticleList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.074%",
    y1: "96.34%",
    x2: "97.925%",
    y2: "-1.855%",
    id: "article-list_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F93333",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF6472",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v6.331c0 .384.277.695.618.695h.149a.586.586 0 00.442-.209l2.067-2.38a.375.375 0 01.579-.002L5.95 6.82a.586.586 0 00.44.206c.34 0 .617-.31.617-.695V0H0z",
    id: "article-list_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 10.146v28.976c0 1.563-1.234 2.831-2.756 2.831H3.756C2.234 41.953 1 40.685 1 39.122V4.785c0-1.564 1.234-2.832 2.756-2.832H23.56L33 10.146z",
    fill: "#FFF",
    stroke: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.96 10.157l-7.554.115c-1.012 0-1.833-.846-1.833-1.888v-6.4l9.387 8.173z",
    stroke: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.201 30.563H7.018a.466.466 0 01-.459-.472c0-.26.206-.472.46-.472H28.2c.254 0 .46.211.46.472 0 .26-.206.472-.46.472M28.201 33.859H7.018a.466.466 0 01-.459-.472c0-.26.206-.472.46-.472H28.2c.254 0 .46.211.46.472 0 .26-.206.472-.46.472M28.201 37.249H7.018a.466.466 0 01-.459-.472c0-.26.206-.472.46-.472H28.2c.254 0 .46.211.46.472 0 .26-.206.472-.46.472",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.496 19.215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "article-list_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#article-list_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v6.331c0 .384.277.695.618.695h.149a.586.586 0 00.442-.209l2.067-2.38a.375.375 0 01.579-.002L5.95 6.82a.586.586 0 00.44.206c.34 0 .617-.31.617-.695V0H0z",
    fill: "url(#article-list_svg__b)",
    mask: "url(#article-list_svg__c)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.4 16.259c0 3.047-2.418 5.517-5.4 5.517s-5.4-2.47-5.4-5.517 2.418-5.517 5.4-5.517 5.4 2.47 5.4 5.517",
    fill: "#FCA75B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.244 16.259c0 2.395-1.9 4.336-4.244 4.336s-4.244-1.941-4.244-4.336c0-2.395 1.9-4.337 4.244-4.337s4.244 1.942 4.244 4.337",
    fill: "#F7C27C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8EE",
    d: "M17 13.422l.816 1.688 1.824.271-1.32 1.315.312 1.856L17 17.676l-1.632.876.312-1.856-1.32-1.315 1.824-.27z"
  })))));
}
export default SvgArticleList;